import {
  useWSModal,
  WSActions,
  WSAlert,
  WSElement,
  WSText
} from "@wingspanhq/fe-component-library";
import { RequirementDefinition } from "@wingspanhq/wingspan-api-sdk";
import React from "react";

import { DefaultActionDetails } from "../components/DefaultActionDetails";

export interface DeleteNotAllowedModalProps {
  requirementDefinition: RequirementDefinition;
  engagementLength: number;
  onClose: () => void;
}

export const DeleteNotAllowedModal: React.FC<DeleteNotAllowedModalProps> = ({
  requirementDefinition,
  engagementLength,
  onClose
}) => {
  return (
    <>
      <DefaultActionDetails
        engagementLength={engagementLength}
        requirementDefinition={requirementDefinition}
      />

      <WSAlert
        icon="alert"
        my="2XL"
        size="M"
        theme="warning"
        title="Requirement cannot be deleted when:"
      >
        <WSElement as="ul" ml="L">
          <li>Associated with active engagements types.</li>
          <li>Historical data (e.g. requirement completion) exists.</li>
        </WSElement>
        <WSText.ParagraphSm mt="M" weight="book">
          If this requirement is no longer used, it can be archived instead.
        </WSText.ParagraphSm>
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </>
  );
};

export const useDeleteNotAllowedModal = () => {
  return useWSModal(DeleteNotAllowedModal, {
    title: "Delete requirement",
    size: "M"
  });
};
